/** Created by azhou on 2018/9/12.*/
<template>
  <!--酒店/民宿用户详细信息-->
  <div class="d-center-start flex-wrap">
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系人"/>{{StoreBasicInfo.contact}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系电话"/>{{StoreBasicInfo.mob}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="办公电话"/>{{StoreBasicInfo.tel}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="总机电话"/>
      {{StoreBasicInfo.hotel_tel || StoreBasicInfo.viewpoint_tel}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="签约类型"/>
      <span class="text-danger" v-if="!StoreBasicInfo.contract">未签约</span>
      <span class="text-blue" v-else>
          {{StoreBasicInfo.contract_arr?StoreBasicInfo.contract_arr.title:''}}（佣金：{{StoreBasicInfo.contract_arr?StoreBasicInfo.contract_arr.yongjin:''}}）
        </span>
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="活跃值"/>{{StoreBasicInfo.exp}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="可用余额"/>{{StoreBasicInfo.money/100 | formatMoney}} 元
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="营业时间"/>
      {{StoreBasicInfo.open_hours ? StoreBasicInfo.open_hours.split('/azhou/')[0] : '未设置'}}
      <el-popover placement="top-start" trigger="hover" v-if="StoreBasicInfo.open_hours" class="ml-1">
        <i class="el-icon-info" slot="reference"></i>
        {{StoreBasicInfo.open_hours.split('/azhou/')[1]}}
      </el-popover>
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="银行卡信息"/>
      已绑定 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','bankcard')">{{StoreBasicInfo.bankcard}}</span>张银行卡
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="景点星级"/>{{StoreBasicInfo.star | formatVar('scenicStarArr')}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="发票信息"/>
      已添加 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','invoice')">{{StoreBasicInfo.invoice}}</span>项发票信息
    </div>
    <div class="w-50" v-if="StoreBasicInfo.type_label">
      <div class="d-center-start mb-3 flex-wrap">
        <left-text leftText="景点主题"/>
        <span v-if="!StoreBasicInfo.theme">未设置</span>
        <el-tag type="warning" v-else v-for="item in StoreBasicInfo.theme.split(',')" :key="item" class="mr-2 mb-2">{{item | formatVar('scenicThemeArr')}}</el-tag>
      </div>
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.banner_pic">
      <left-text leftText="轮播大图"/>
      已上传<span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','pic')">{{StoreBasicInfo.banner_pic.split(',').length}}</span>张
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.pic">
      <left-text leftText="景点图片"/>
      已上传<span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','pic')">{{StoreBasicInfo.pic.length}}</span>张
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text :leftText="$route.query.type == 8 ? '活动数量' : '门票数量'"/>
      <span class="text-link ml-1 mr-1" v-if="StoreBasicInfo.ticketArr" @click="$emit('showItemDetail','ticket')">{{StoreBasicInfo.ticketArr.ticket_nums}}</span>个
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name:'ScenicUser',
    data () {
      return {
        showIndex: 0,                       //展示酒店/民宿某一项-外景图，内景图，房型信息，会议室信息
        currentRoomMeet: null,             //当前查看的房型/会议室照片
        showRoomMeetIndex: '',              //查看房间会议室照片
        bankcardLists: [],                  //银行卡列表
        invoiceLists: [],                   //发票列表
        type: 0
      }
    },
    computed: {
      ...mapState(['StoreBasicInfo']),
    },
  }
</script>
